
import React from 'react';
import TooltipExplanation from './TooltipExplanation';

interface CompatibilityMetricProps {
  label: string;
  value: number;
  color: string;
  explanation: string;
}

const CompatibilityMetric: React.FC<CompatibilityMetricProps> = ({
  label,
  value,
  color,
  explanation
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-1">
        <span className="text-xs">
          <TooltipExplanation 
            text={label} 
            explanation={explanation}
          />
        </span>
        <span className="text-xs font-medium">
          {Math.round(value)}%
        </span>
      </div>
      <div className="bg-muted rounded-full h-1.5 overflow-hidden">
        <div 
          className={`${color} h-full rounded-full`} 
          style={{ width: `${value}%` }}
        ></div>
      </div>
    </div>
  );
};

export default CompatibilityMetric;
